import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "airConditioning"
const AirConditioningIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.256 4.861 16.6 2.532 17.9 3.282 16.554 5.612 19.416 4.843 19.804 6.293 15.494 7.448 13.298 11.25H17.689L20.845 8.095 21.905 9.155 19.811 11.25H22.5V12.75H19.81L21.906 14.845 20.845 15.905 17.69 12.75H13.298L15.494 16.552 19.804 17.707 19.416 19.156 16.554 18.389 17.9 20.718 16.6 21.468 15.256 19.138 14.489 22 13.04 21.612 14.195 17.302 12 13.499 9.804 17.302 10.96 21.612 9.511 22.001 8.744 19.139 7.399 21.468 6.1 20.718 7.445 18.388 4.583 19.157 4.196 17.707 8.505 16.552 10.702 12.75H6.31L3.155 15.905 2.095 14.845 4.189 12.75H1.5V11.25H4.19L2.094 9.155 3.155 8.095 6.311 11.25H10.7L8.506 7.448 4.196 6.293 4.583 4.844 7.445 5.611 6.1 3.282 7.4 2.532 8.744 4.862 9.51 2 10.959 2.388 9.804 6.698 12 10.5 14.195 6.698 13.04 2.388 14.489 2z" />
        </svg>
      }
    </span>
  )
}
export default AirConditioningIcon
